exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/kalinin/angular2/PRACTICE/feedback/src/app/feedback/feedback.component.scss
// module id = ../../../../../src/app/feedback/feedback.component.scss
// module chunks = 1